import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DateTimeFormatter, LocalDateTime } from "@js-joda/core";
import Background from '../asserts/pic.png';
import { authFetch } from '../auth';

const FLY_PER_PAGE = 10;

const FlyListPage = () => {
  const [flies, setJumps] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const navigate = useNavigate();

  useEffect(() => {
    authFetch("/api/flydata/fly-list")
      .then(res => res.json())
      .then(data => setJumps(data));
  }, []);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedFlies = [...flies].sort((a, b) => {
    if (!sortColumn) return 0;

    const aValue = a[sortColumn];
    const bValue = b[sortColumn];

    if (typeof aValue === "number") {
      return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
    }

    return sortDirection === "asc"
      ? String(aValue).localeCompare(String(bValue))
      : String(bValue).localeCompare(String(aValue));
  });

  const totalPages = Math.ceil(flies.length / FLY_PER_PAGE);
  const currentFlies = sortedFlies.slice(
    (currentPage - 1) * FLY_PER_PAGE,
    currentPage * FLY_PER_PAGE
  );

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        padding: "40px 20px",
        fontFamily: "Segoe UI, sans-serif",
        color: "#fff",
        backdropFilter: "blur(4px)",
        backgroundImage: `url(${Background})`,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
        <Link to="/" style={{
          backgroundColor: "#FFD700",
          color: "#000",
          padding: "8px 16px",
          borderRadius: "8px",
          textDecoration: "none",
          fontWeight: "bold",
          boxShadow: "2px 2px 4px rgba(0,0,0,0.3)"
        }}>
          ⬅ На главную
        </Link>
        <h1 style={{
          fontSize: "2.5rem",
          margin: 0,
          textShadow: "2px 2px 4px #000",
          flexGrow: 1,
          textAlign: "center"
        }}>
          📋 Список полетов в аэротрубе
        </h1>
        <div style={{ width: "110px" }}></div>
      </div>

      <div style={{
        backgroundColor: "rgba(42, 18, 99, 0.69)",
        borderRadius: "12px",
        padding: "20px",
        maxWidth: "900px",
        margin: "0 auto",
      }}>
        <div style={{ display: "flex", fontWeight: "bold", padding: "10px 0", borderBottom: "1px solid #555" }}>
          <div style={{ flex: 1, cursor: "pointer", paddingLeft: "12px" }} onClick={() => handleSort("flyNumber")}>
            🌀 # {sortColumn === "flyNumber" ? (sortDirection === "asc" ? "▲" : "▼") : ""}
          </div>
          <div style={{ flex: 2, cursor: "pointer" }} onClick={() => handleSort("dateTime")}>
            📅 Дата {sortColumn === "dateTime" ? (sortDirection === "asc" ? "▲" : "▼") : ""}
          </div>
          <div style={{ flex: 3, cursor: "pointer", paddingLeft: "16px" }} onClick={() => handleSort("windtunnel")}>
            📍 Локация {sortColumn === "windtunnel" ? (sortDirection === "asc" ? "▲" : "▼") : ""}
          </div>
          <div style={{ flex: 2, cursor: "pointer" }} onClick={() => handleSort("duration")}>
            &#128339; Время полета (мин) {sortColumn === "duration" ? (sortDirection === "asc" ? "▲" : "▼") : ""}
          </div>
          <div style={{ flex: 2, cursor: "pointer" }} onClick={() => handleSort("hasTime")}>
            &#128200; Остался депозит (мин) {sortColumn === "hasTime" ? (sortDirection === "asc" ? "▲" : "▼") : ""}
          </div>
        </div>

        {currentFlies.map(fly => (
          <div
            key={fly.id}
            onClick={() => navigate(`/fly/${fly.flyNumber}`)}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 0",
              borderBottom: "1px solid #444",
              transition: "background 0.2s",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255, 217, 0, 0.34)"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
          >
            <div style={{ flex: 1, paddingLeft: "12px" }}>{fly.flyNumber}</div>
            <div style={{ flex: 2 }}>{LocalDateTime.parse(fly.dateTime).format(DateTimeFormatter.ofPattern('dd.MM.yyyy HH:mm'))}</div>
            <div style={{ flex: 3, paddingLeft: "16px" }}>{fly.windtunnel}</div>
            <div style={{ flex: 2 }}>{fly.duration} мин</div>
            <div style={{ flex: 2 }}>{fly.hasTime} мин</div>
          </div>
        ))}

        <div style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
          gap: "8px",
          flexWrap: "wrap"
        }}>
          <button
            onClick={() => changePage(currentPage - 1)}
            disabled={currentPage === 1}
            style={paginationButtonStyle(currentPage === 1)}
          >
            « Назад
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
            <button
              key={page}
              onClick={() => changePage(page)}
              style={{
                ...paginationButtonStyle(false),
                fontWeight: page === currentPage ? "bold" : "normal",
                backgroundColor: page === currentPage ? "#FFD700" : "#333",
                color: page === currentPage ? "#000" : "#fff",
              }}
            >
              {page}
            </button>
          ))}

          <button
            onClick={() => changePage(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={paginationButtonStyle(currentPage === totalPages)}
          >
            Вперёд »
          </button>
        </div>
      </div>
    </div>
  );
};

const paginationButtonStyle = (disabled) => ({
  backgroundColor: "#444",
  color: "#fff",
  padding: "8px 14px",
  borderRadius: "6px",
  border: "none",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.5 : 1,
});

export default FlyListPage;
